module.exports = __webpack_public_path__ + "img/tab-image-sport-presentation.c3c006f3.png";